// inv/src/lib/amountBins.js
export const getAmountRangeByCode = (code) => {
  const ranges = {
    1: '< $50k',
    2: '$50k-100k',
    3: '$100k-200k',
    4: '$200k-500k',
    5: '$500k-1M',
    6: '$1M-2M',
    7: '$2M-10M',
    8: '$10M-50M',
    9: '> $50M',
  };

  return ranges[code] || 'Unknown';
};

export const getAmountRangeDetailed = (code) => {
  const ranges = {
    1: '< $50,000',
    2: '$50,000 - $100,000',
    3: '$100,000 - $200,000',
    4: '$200,000 - $500,000',
    5: '$500,000 - $1,000,000',
    6: '$1,000,000 - $2,000,000',
    7: '$2,000,000 - $10,000,000',
    8: '$10,000,000 - $50,000,000',
    9: '> $50,000,000',
  };

  return ranges[code] || 'Unknown';
};

export const AMOUNT_BINS = [
  { code: 1, min: -Infinity, max: 50000, label: '< $50k', detailedLabel: '< $50,000' },
  { code: 2, min: 50000, max: 100000, label: '$50k-100k', detailedLabel: '$50,000 - $100,000' },
  { code: 3, min: 100000, max: 200000, label: '$100k-200k', detailedLabel: '$100,000 - $200,000' },
  { code: 4, min: 200000, max: 500000, label: '$200k-500k', detailedLabel: '$200,000 - $500,000' },
  { code: 5, min: 500000, max: 1000000, label: '$500k-1M', detailedLabel: '$500,000 - $1,000,000' },
  { code: 6, min: 1000000, max: 2000000, label: '$1M-2M', detailedLabel: '$1,000,000 - $2,000,000' },
  { code: 7, min: 2000000, max: 10000000, label: '$2M-10M', detailedLabel: '$2,000,000 - $10,000,000' },
  { code: 8, min: 10000000, max: 50000000, label: '$10M-50M', detailedLabel: '$10,000,000 - $50,000,000' },
  { code: 9, min: 50000000, max: Infinity, label: '> $50M', detailedLabel: '> $50,000,000' },
];

export default {
  getAmountRangeByCode,
  getAmountRangeDetailed,
  AMOUNT_BINS,
};

